import { getBuilding } from '@full-elevator/content';

/**
 * What a floor is called (ADR-0028).
 *
 * The sim counts floors from the bottom of the shaft. A player counts them from
 * the street, as every lift panel does: in the Transit Centre the metro platform
 * is two floors under the pavement, so it is −2, the ticket hall −1 and the
 * street 0. Only the names move — the floor, its colour and every rule about it
 * are the sim's, unchanged.
 */

/** Which floor of a building is at street level: 0 unless the building says. */
export function groundOf(buildingId: string | undefined): number {
  return buildingId === undefined ? 0 : (getBuilding(buildingId).groundFloor ?? 0);
}

/** A floor as the player reads it, counted from the street: "3", "0", "−2". */
export function floorName(floor: number, ground: number): string {
  const storey = floor - ground;
  // A true minus sign, as on a lift panel, not a hyphen.
  return storey < 0 ? `−${-storey}` : String(storey);
}
